// src/contexts/BlogArticleContext.jsx

import React, { createContext, useState } from 'react';

// Este contexto guardará el artículo actual (y sus traducciones)
export const BlogArticleContext = createContext({
  currentBlogArticle: null,
  setCurrentBlogArticle: () => {},
});

export function BlogArticleProvider({ children }) {
  const [currentBlogArticle, setCurrentBlogArticle] = useState(null);

  return (
    <BlogArticleContext.Provider value={{ currentBlogArticle, setCurrentBlogArticle }}>
      {children}
    </BlogArticleContext.Provider>
  );
}
